// The latest list can be found on ABS website: http://www.abs.org.sg/financial_giro.php
export interface BankBic {
   CODE: string;
   NAME: string;
   BIC: string;
}
export const BankBicOptions: BankBic[] = [{ CODE: '7931', NAME: 'Australia & New Zealand Banking Group Limited', BIC: 'ANZBSGSXXXX' },
  { CODE: '7047', NAME: 'Bangkok Bank Public Company Limited', BIC: 'BKKBSGSGXXX' },
  { CODE: '7065', NAME: 'Bank Of America, N.A.', BIC: 'BOFASG2XXXX' },
  { CODE: '7083', NAME: 'Bank Of China Limited', BIC: 'BKCHSGSGXXX' },
  { CODE: '7108', NAME: 'Bank Of India', BIC: 'BKIDSGSGXXX' },
  { CODE: '7126', NAME: 'Bank Of Tokyo-Mitsubishi UFJ, Limited', BIC: 'BOTKSGSXXXX' },
  { CODE: '7418', NAME: 'BNP Paribas', BIC: 'BNPASGSGXXX' },
  { CODE: '9353', NAME: 'Chinatrust Commercial Bank Co. Limited', BIC: 'CTCBSGSGXXX' },
  { CODE: '7986', NAME: 'CIMB Bank Berhad', BIC: 'CIBBSGSGXXX' },
  { CODE: '7214', NAME: 'Citibank N.A.', BIC: 'CITISGSGXXX' },
  { CODE: '8606', NAME: 'Commerzbank Aktiengesellschaft', BIC: 'COBASGSXXXX' },
  { CODE: '7135', NAME: 'Crédit Agricole Corporate And Investment Bank', BIC: 'CRLYSGSGXXX' },
  { CODE: '7171', NAME: 'DBS Bank Limited', BIC: 'DBSSSGSGXXX' },
  { CODE: '7463', NAME: 'Deutsche Bank AG', BIC: 'DEUTSGSGXXX' },
  { CODE: '7737', NAME: 'DNB Bank ASA', BIC: 'DNBASGSGXXX' },
  { CODE: '7199', NAME: 'Far Eastern Bank Limited', BIC: 'FAEASGSGXXX' },
  { CODE: '7764', NAME: 'First Commercial Bank', BIC: 'FCBKSGSGXXX' },
  { CODE: '7287', NAME: 'HL Bank', BIC: 'HLBBSGSGXXX' },
  { CODE: '9186', NAME: 'ICICI Bank Limited', BIC: 'ICICSGSGXXX' },
  { CODE: '7241', NAME: 'Indian Bank', BIC: 'IDIBSGSGXXX' },
  { CODE: '7250', NAME: 'Indian Overseas Bank', BIC: 'IOBASGSGXXX' },
  { CODE: '8712', NAME: 'Industrial & Commercial Bank Of China', BIC: 'ICBKSGSGXXX' },
  { CODE: '8350', NAME: 'Intesa Sanpaolo S.P.A.', BIC: 'BCITSGSGXXX' },
  { CODE: '7153', NAME: 'JPMorgan Chase Bank, N.A.', BIC: 'CHASSGSGXXX' },
  { CODE: '7490', NAME: 'Korea Exchange Bank', BIC: 'KOEXSGSGXXX' },
  { CODE: '8873', NAME: 'Landesbank Baden- Wurttemberg', BIC: 'SOLASGSGXXX' },
  { CODE: '7302', NAME: 'Malayan Banking Berhad', BIC: 'MBBESGSGXXX' },
  { CODE: '7621', NAME: 'Mizuho Bank Limited', BIC: 'MHCBSGSGXXX' },
  { CODE: '8077', NAME: 'National Australia Bank Limited', BIC: 'NATASGSGXXX' },
  { CODE: '8518', NAME: 'Nordea Bank Finland PLC', BIC: 'NDEASGSGXXX' },
  { CODE: '7339', NAME: 'Oversea-Chinese Banking Corpn Limited', BIC: 'OCBCSGSGXXX' },
  { CODE: '7056', NAME: 'PT Bank Negara Indonesia (Persero) TBK', BIC: 'BNINSGSGXXX' },
  { CODE: '7366', NAME: 'RHB Bank Berhad', BIC: 'RHBBSGSGXXX' },
  { CODE: '8527', NAME: 'Skandinaviska Enskilda Banken AB (Publ)', BIC: 'ESSESGSGXXX' },
  { CODE: '7852', NAME: 'Societe Generale', BIC: 'SOGESGSGXXX' },
  { CODE: '7144', NAME: 'Standard Chartered Bank', BIC: 'SCBLSG22XXX' },
  { CODE: '7791', NAME: 'State Bank Of India', BIC: 'SBINSGSGXXX' },
  { CODE: '7472', NAME: 'Sumitomo Mitsui Banking Corporation', BIC: 'SMBCSGSGXXX' },
  { CODE: '8493', NAME: 'Svenska Handelsbanken AB (Publ)', BIC: 'HANDSGSGXXX' },
  { CODE: '7092', NAME: 'The Bank Of East Asia Limited', BIC: 'BEASSGSGXXX' },
  { CODE: '7232', NAME: 'The Hongkong And Shanghai Banking Corporation Limited', BIC: 'HSBCSGSGXXX' },
  { CODE: '7010', NAME: 'The Royal Bank Of Scotland PLC', BIC: 'ABNASGSGXXX' },
  { CODE: '9733', NAME: 'TRUST BANK SINGAPORE LIMITED', BIC: 'TRBUSGSGXXX' },
  { CODE: '7685', NAME: 'UBS AG', BIC: 'UBSWSGSGXXX' },
  { CODE: '7357', NAME: 'UCO Bank', BIC: 'UCBASGSGXXX' },
  { CODE: '7375', NAME: 'United Overseas Bank Limited', BIC: 'UOVBSGSGXXX' }]

export function MapBankNameToBankCode (srcBankName = '') {
  if (!srcBankName) return ''
  const foundBank = BankBicOptions.find(bank => bank.NAME === srcBankName)
  if (foundBank) {
    return foundBank.CODE
  }
  return srcBankName
}
